import { cn } from "@/lib/utils";

export const Logo = ({
  className,
  "aria-hidden": ariaHidden,
}: {
  className?: string;
  "aria-hidden"?: boolean | "true" | "false";
}) => (
  <svg
    viewBox="0 0 280 50"
    className={cn("h-8 w-auto", className)}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
  >
    <path
      d="M5 35L25 10L45 35"
      stroke="hsl(var(--accent))"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 35V25M35 35V25"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <text
      x="60"
      y="34"
      fontFamily="sans-serif"
      fontSize="22"
      fontWeight="900"
      fill="currentColor"
      letterSpacing="-0.5"
    >
      SASK ROOFING CO.
    </text>
  </svg>
);
